import { Record as record } from 'immutable';

import config from '../../../../src/config';
import validators from '../../../../src/validation';
import ValidationMixin from '../../../../src/records/ValidationMixin';
import { getDefaults, getResolvers } from '../../../../src/helpers/Records';
import { construct, fields } from '../../../../src/helpers/LinkMapper';

const fieldSchema = {
    "title": [ fields.string, config.get('customerTitles')[0] ],
    "firstNames": [ fields.string ],
    "surname": [ fields.string ],
    "email": [ fields.string ],
    "phone": [ fields.string ]
};

export default class CompensationCustomer extends record(getDefaults(fieldSchema)) {
    static fromJSON(json = {}) {
        return construct(CompensationCustomer, json, getResolvers(fieldSchema));
    }

    getSchema () {
        return {
            title: validators.title(),
            firstNames: validators.name(2, 50),
            surname: validators.name(2, 50),
            email: validators.email(),
            phone: validators.phone().required()
        };
    }

    isUntouched () {
        return this.equals(new CompensationCustomer());
    }

    initialiseWithUser (user) {
        return this.merge({
            title: user.title,
            firstNames: user.firstNames,
            surname: user.surname,
            email: user.email,
            phone: user.telephoneNumber
        });
    }
}

Object.assign(CompensationCustomer.prototype, ValidationMixin);
